import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpSquareFilledSvg from "@ant-design/icons-svg/es/asn/UpSquareFilled";
import AntdIcon from "../components/AntdIcon";
var UpSquareFilled = function UpSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpSquareFilled.displayName = 'UpSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(UpSquareFilled);